@if (control && control.invalid && (control.dirty || control.touched)) {
    @if (control.errors) {
        @if (control.errors['required']) {
            <div class="form-text text-danger">{{ 'REQUIRED_FIELD' | translate }}</div>
        }
        @if (control.errors['min']) {
            <div class="form-text text-danger">{{ 'ERROR_FIELD_MIN' | translate | stringFormat : [control.errors['min'].min.toString()] }}</div>
        }
        @if (control.errors['max']) {
            <div class="form-text text-danger">{{ 'ERROR_FIELD_MAX' | translate | stringFormat : [control.errors['max'].max.toString()] }}</div>
        }
        @if (control.errors['naming']) {
            <div class="form-text text-danger">{{ 'ERROR_FIELD_NAMING' | translate }}</div>
        }
        @if (control.errors['onlySpace']) {
            <div class="form-text text-danger">{{ 'ERROR_FIELD_ONLY_SPACE' | translate }}</div>
        }
        @if (control.errors['email']) {
            <div class="form-text text-danger">{{ 'REGISTERFORM_PASSWORDPATTERN_ERROR' | translate }}</div>
        }
        @if (customErrorMsg) {
            <div class="form-text text-danger" [innerHTML]="customErrorMsg"></div>
        }
    }
}
